import hanghae from "/public/images/landing/brands/hanghae.png";
import chang from "/public/images/landing/brands/chang.png";
import swc from "/public/images/landing/brands/swc.png";

export const brands = [
  {
    title: "99일만에 개발자 취업",
    subtitle: "개발자 부트캠프 항해99",
    logo: hanghae,
    logoName: "hanghae",
  },
  {
    title: "퇴근 후 창업가로",
    subtitle: "직장인 창업 부트캠프 {창}",
    logo: chang,
    logoName: "chang",
  },
  {
    title: "직장 병행 커리어 전환",
    subtitle: "IT 취업 부트캠프 SW캠프",
    logo: swc,
    logoName: "swc",
  },
];
